<template>
    <a11y-dialog id="admission-dialog" @dialog-ref="assignDialogRef" dialog-root="#admission-modal-root"
        close-button-label="Close" close-button-position="none" :class-names="classes">
        <div class="c-modal__head">
            <div class="c-modal__info-wrap">
                <h3 class="c-col-title">{{ titles.heading }}</h3>
                <p v-html="subtitle"></p>
                <span class="c-modal__date" v-if="dateLabel.length">
                    <i class="fal fa-calendar-days" aria-hidden="true"></i>
                    <span>{{ dateLabel }}</span>
                </span>
            </div>

            <button class="c-modal__head-button" data-a11y-dialog-hide aria-label="Close the admission calendar modal">
                Close
                <span class="fas fa-times" aria-hidden="true"></span>
            </button>
        </div>

        <div class="c-modal__wrap">
            <div class="c-modal__content c-modal__content--general-admissions" v-if="content">
                <div class="c-modal__content--general-admissions-general" v-if="content.general.length">
                    <div class="c-wysiwyg" v-html="content.general"></div>
                </div>
                <div class="c-modal__content--general-membership" :class="{ 'no-content': !content.general }"
                    v-if="content.memberships.length">
                    <div class="c-event-instance__memberdetails c-wysiwyg" v-html="content.memberships"></div>
                </div>
                <Admissions :first-admission="firstAdmission" :last-admission="lastAdmission" />
            </div>
        </div>

        <!-- Required title for modal. Visually hidden -->
        <template v-slot:title>
            <span>{{ titles.hidden }}</span>
        </template>
    </a11y-dialog>
</template>

<script>
import { A11yDialog } from 'vue-a11y-dialog'
import Admissions from "./Admissions"

export default {
    name: "AdmissionsModal",
    props: {
        dateLabel: String,
        eventTitle: String,
        firstAdmission: String,
        lastAdmission: String,
    },
    components: {
        "a11y-dialog": A11yDialog,
        Admissions,
    },
    data() {
        return {
            dialog: null,
            isOpen: false,
            content: window.admissions.messages,
            classes: {
                container: 'c-modal c-modal--general-admissions',
                document: 'c-modal__container',
                overlay: 'c-modal__backdrop',
                title: 'u-hidden-visually',
            },
            titles: {
                hidden: 'General admissions calendar. View the dates where general admission to the museum is available.',
                heading: 'Book Now'
            },
            subtitle: this.subtitleText()
        }
    },
    methods: {
        assignDialogRef(dialog) {
            this.dialog = dialog
            this.dialog.on('show', (dialogEl, event) => {
                this.isOpen = true
                this.$emitter.emit('state--modal-open')
                document.body.classList.add('state--modal-open')
                const modalWrap = dialogEl.querySelector('.c-modal__wrap')
                modalWrap.scrollTo(0, 0)
            })

            this.dialog.on('hide', (dialogEl, event) => {
                this.isOpen = false
                const modalWrap = dialogEl.querySelector('.c-modal__wrap')
                document.body.classList.remove('state--modal-open')
                modalWrap.scrollTo(0, 0)
            })

            if (window.location.hash == '#admissions') {
                this.dialog.show()
            }
        },
        subtitleText() {
            if (this.eventTitle.length) {
                return `For Museum admission, including <span class='c-modal__exhibition-name'>${this.eventTitle}</span>`
            }

            return 'For admissions to all of our galleries and exhibitions'
        }
    }
}
</script>

<style scoped>

</style>
